import { withRouter } from "react-router-dom";
import { NewOrderComponent } from "./new-order.component";
import { NovaposhtaModule } from "@components/modules/novaposhta";
import { connect } from 'react-redux'
import { Orders } from "@components/orders";
import {Products} from "@components/product";
import { Clients } from "@components/clients";
import withStyles from '@material-ui/core/styles/withStyles';
import combineStyles from '~/utils/styles';
import form from '@style/form'
import modal from '@style/modal'
import styles from './styles';

const mapStateToProps = (state, props) => ({
    context: state.context || {},
});

const actions = {
    getOrderDetails: Orders.actions.getOrderDetails,
    updateOrderDetails: Orders.actions.updateOrderDetails,
    getNovaposhtaModuleConfiguration: NovaposhtaModule.actions.getModulesConfiguration,
    getProductByBarcode: Products.actions.getProductByBarcode,
    findClientDeliveryDetails: Clients.actions.findClientDeliveryDetails,
    getDefaultOrderData: Orders.actions.getDefaultOrderData,
    getPriceGroupData: Orders.actions.getPriceGroupData,
    getCurrencyData: Orders.actions.getCurrencyData,
};

export const NewOrderContainer = connect(mapStateToProps, actions)((withRouter(withStyles(combineStyles(form, modal, styles))(NewOrderComponent))));
